module.exports.create = (function () {
  function F() {};

  return function (o) {
    if (arguments.length != 1) {
      throw new Error('Object.create implementation only accepts one parameter.');
    }
    F.prototype = o;
    return new F();
  }
})();


//////////////////
// WEBPACK FOOTER
// ./~/sc-emitter/objectcreate.js
// module id = 1097
// module chunks = 31 32 33